import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import { getCurrentUserSession } from "../../../services/auth/authService";
import { decodeToken } from "react-jwt";
import collectionScheduleService from "../../../services/collection/collectionScheduleService";
import CollectionScheduleDetail from "./collectionScheduleDetail";
import ModifyCollectionConfig from "./modifyCollectionConfig";

export interface CollectionSchedulesProps {}

export interface CollectionSchedulesState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  allItems: any;
}

class CollectionSchedulesList extends BaseListComponent<CollectionSchedulesState> {}

class CollectionSchedules extends React.Component<
  CollectionSchedulesProps,
  CollectionSchedulesState
> {
  constructor(props: CollectionSchedulesProps) {
    super(props);
    this.state = {
      data: createFilterData([]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      allItems: [],
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    // const decodedToken = decodeToken(getCurrentUserSession().token || "");
    // let dataClone =
    //   typeof data === "undefined" ? { ...this.state.data } : { ...data };
    try {
      const decodedToken = decodeToken(getCurrentUserSession().token || "");
      const collSchedules = await collectionScheduleService.retrieveCollectionSchedulesByInstitutionCode(decodedToken?.["InstitutionCode"]?.toString() || "");

      // dataClone["institutionId"] = {
      //   item1: "=",
      //   item2: decodedToken?.["InstitutionId"]?.toString() || "",
      // };
      // const collectionSchedules = await collectionScheduleservice.filterPagedCollectionSchedules(
      //   dataClone,
      //   Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      //   currentPage
      // );
      const collectionSchedules: any = [];
      const totalLength = collSchedules.data.length;
      const initial = (currentPage - 1) * pageSize;
      for (let i = initial; i < initial + pageSize; i++) {
        collectionSchedules.push(collSchedules.data[i]);
        if (i === totalLength - 1) {
          break;
        }
      }

      this.setState({
        tableItems: mapEntityList({
          // entityList: collectionSchedules.data.item2,
          entityList: collectionSchedules,
          properties: [
            { oldName: "customerName", newName: "name" },
            { oldName: "bvn", newName: "bvn" },
            { oldName: "mandateReference", newName: "mandateReference" },
            { oldName: "totalExpectedRepayment", newName: "totalExpectedRepayment" },
            { oldName: "loanExpiryDate", newName: "loanExpiryDate" },
            // { oldName: "dateUpdated", newName: "dateUpdated" },
          ],
        }),
        currentPage,
        pageSize,
        // totalSize: collectionSchedules.data.item1,
        totalSize: totalLength,
        fetching: false,
        allItems: collSchedules.data,
      });
          
    // public string CustomerName { get; set; }
    // public string PhoneNumber { get; set; }
    // public string Bvn { get; set; }
    // public string MandateReference { get; set; }
    // public string ExternalMandateReference { get; set; }
    // public decimal TotalExpectedRepayment { get; set; }
    // public DateTime LoanExpiryDate { get; set; }
    // public int LoanTenure { get; set; }
    // public string LoanStatus { get; set; }
    // public string InstitutionCode { get; set; }
    // public DateTime DateCreated { get; set; }
    // public DateTime? DateUpdated { get; set; }
    // public DateTime? DateRestructured { get; set; }
    // public string RecoverySwitchMode { get; set; }
    // public int? SwitchRecoveryWindowInDays { get; set; }
    // public List<CollectionScheduleRepaymentDto> ScheduleRepayments { get; set; }
    } catch (ex) {
      //   console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        this.setState({ fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        this.setState({ fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => {};

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true });
    try {
      const collectionSchedule = await collectionScheduleService.retrieveCollectionScheduleById(item.id);
      // console.log("details:: ", collectionSchedule.data)
      this.setState({ item: collectionSchedule.data, fetchingDetail: false });
    } catch (error) {
      // console.log(error.response);
      this.setState({ fetchingDetail: false });
    }
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    // console.log("asfsdf", this.state.filterValueInput);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Collection Schedules</b>
              </h3>
            </div>
            <CollectionSchedulesList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              //   updateState={this.state.updateBaseListState}
              initialValues={{
                data: createFilterData([]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <CollectionScheduleDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    reloadDetails={() => this.fetchItemById(item)}
                    showTrail={null}
                    // currentUserRoles={null}
                    item={item}
                  />
                  <ModifyCollectionConfig
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      this.setState({
                        showDetailsModal: !this.state.showDetailsModal,
                      });
                    }}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Collection Schedules"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={["totalExpectedRepayment"]}
                              amountInNaira={true}
                              timeColumn={["loanExpiryDate"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></CollectionSchedulesList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CollectionSchedules;
